export class LqdDrawSHapeHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initThrowable();

  }

  getDefaultSettings() {
    return {
      selectors: {
        throwableScene: '[data-lqd-throwable-scene]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $throwableScene: this.$element.find(selectors.throwableScene),
    }
  }

  initThrowable() {

    this.elements.$throwableScene.liquidThrowable();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleThrowableDestroy();

  }

  handleThrowableDestroy() {

    if ( ! this.elements.$throwableScene.length ) return;

    const throwableData = this.elements.$throwableScene.data('plugin_liquidThrowable');

    if ( throwableData ) {
      throwableData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdDrawSHapeHandler, { $element } );
};